import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Outlet,
  Link,
  useNavigate,
  useParams
} from "react-router-dom";
import { useMutation, ClientContext, GraphQLClient } from "graphql-hooks";
import { createMuiTheme, makeStyles, ThemeProvider } from "@material-ui/core";

import Header from "./components/Header";
import Footer from "./components/Footer";
import typography from "./theme/typography";
import palette from "./theme/palette";

import ApplicantsAnswersScores from "./adminPages/ApplicantsAnswersScores";
import AdminSignIn from "./adminPages/signIn/adminSignIn";
import AdminDashboard from "./adminPages/adminHome";
import SiteAdminSideMenu from "./adminPages/SiteAdminSideMenu";
import AdminLogout from "./adminPages/logout/adminLogout";

import SignIn from "./userPages/signIn/signIn";
import Logout from "./userPages/logout/logout";
import ForgetPass from "./userPages/forgetPassword/forgetPass";
import ResetPass from "./userPages/resetPassword/resetPass";
import ResetPassConfirmation from "./userPages/resetPassword/ResetPassConfirmation";
import Home from "./userPages/Home";
import Registration from "./userPages/registration/registration";
import SuccessRegistration from "./userPages/registration/successRegistration";
import Activation from "./userPages/activation/activation";
import ApplicantActivation from "./userPages/applicants/applicantActivation";
import AccountActivation from "./userPages/users/AccountActivation";
import ApplicantActivationConfirmation from "./userPages/applicants/applicantActivationConfirmation";
import AccountActivationConfirmation from "./userPages/users/AccountActivationConfirmation";
import OnboardedMemberActivation from "./userPages/volunteers/OnboardedMemberActivation";
import OnboardedMemberActivationConfirmation from "./userPages/volunteers/OnboardedMemberActivationConfirmation";
import FormContainer from "./userPages/forms/FormContainer.js";
import UserContainer from "./userPages/users/UserContainer.js";
import UserGroups from "./userPages/users/UserGroups.js";
import UserGroupPermissions from "./userPages/users/UserGroupPermissions.js";
import UserCombinedGroupPermissions from "./userPages/users/UserCombinedGroupPermissions.js";
import FormContainerSP from "./userPages/forms/FormContainer_SP.js";
import RTETest from "./tests/rteTest.js";
import TenantTest from "./tests/tenantTest.js";

import FormDialog from "./userPages/forms/FormDialog";
import OrderFormDialog from "./userPages/forms/OrderFormDialog";
import FormPreview from "./userPages/forms/FormPreview";
import PublicForm from "./userPages/forms/PublicForm";
import ClientPublicForm from "./userPages/forms/ClientPublicForm";
import SubmittedForm from "./userPages/forms/SubmittedForm";
//import SuccessForm from "./userPages/forms/SuccessForm";
//import VolunteerForm from "./userPages/forms/VolunteerForm";
//import TenantUserForm from "./userPages/forms/TenantUserForm";

import OrderFormDialogSP from "./userPages/forms/OrderFormDialog_SP";
import ScorePage from "./userPages/score/ScorePage.js";
import TenantSideMenu from "./userPages/TenantSideMenu";
import ApplicantSideMenu from "./userPages/ApplicantSideMenu";
import ApplicantsBoard from "./userPages/applicants/applicantsBoard";
import ApplicantsBoardFull from "./userPages/applicantsFull/applicantsBoard";
import { project_url, admin_string, secretPass, MULTI_TENANT } from "./constants/Data";

import AddTerm from "./userPages/terms/termAdd.js";
import AddTermUI from "./userPages/terms/termAdd-ui.js";
import Terms from "./userPages/terms/termList.js";
import EditTerm from "./userPages/terms/termEdit.js";
import TeamsAssignment from "./userPages/terms/teamsAssignment.js";
import TeamsAssignmentFull from "./userPages/terms/teamsAssignmentFull.js";
import TeamsResourcesNotes from "./userPages/terms/TeamsResourcesNotes.js";
import TeamsResourcesAttendance from "./userPages/terms/teamsResourcesAttendance";

import Teams from "./userPages/teams/teamList.js";
import AddTeam from "./userPages/teams/teamAdd.js";
import TeamDetail from "./userPages/teams/teamDetail.js";
import TeamTermsList from "./userPages/teams/TeamTermsList.js";
import TeamTermActivity from "./userPages/teams/teamTermActivities.js";

import Clients from "./userPages/clients/clientList.js";
import AddClient from "./userPages/clients/clientAdd.js";
import EditClient from "./userPages/clients/clientEdit.js";
import AddUser from "./userPages/users/userAdd.js";
import EditUser from "./userPages/users/userEdit.js";
import Tenant from "./userPages/tenants/tenant.js";
import TenantUI from "./userPages/tenants/tenant-ui.js";
import TenantSettings from "./userPages/tenants/tenantSettings.js";
import ManageEventTypes from "./userPages/tenants/manageEventTypes.js";
import ManageRoles from "./userPages/tenants/manageRoles.js";
import ManageTermTemplates from "./userPages/termTemplates/manageTermTemplates.js";
import TermTemplatesDetail from "./userPages/termTemplates/termTemplateEdit.js";

import ManageCountries from "./userPages/tenants/manageCountries.js";
import ManageStates from "./userPages/tenants/manageStates.js";
import ConfigureTermSettings from "./userPages/tenants/configureTermSettings.js";

import AddGroup from "./userPages/groups/groupAdd.js";
import Groups from "./userPages/groups/groupList.js";
import GroupDetail from "./userPages/groups/groupDetail.js";
import GroupPermissions from "./userPages/groups/groupPermission.js";
import GroupPermissionsUI from "./userPages/groups/groupPermissionUI.js";

import Applicant from "./userPages/applicantUsers/applicant.js";
import Applications from "./userPages/applicantUsers/applicationList.js";
import ApplicationView from "./userPages/applicantUsers/applicationFormView.js";

import Volunteers from "./userPages/volunteers/volunteerList.js";
import ClientMembersList from "./userPages/volunteers/ClientMembersList.js";
import ClientMembersAdd from "./userPages/volunteers/ClientMembersAdd.js";

import Profile from "./userPages/profile/Profile";
import Settings from "./userPages/settings/Settings";
import ToBeDev from "./userPages/ToBeDev";
import ApplicantProfile from "./userPages/applicantProfile/Profile";

import ApplicantCurrentSprint from "./userPages/applicantCurrentSprint/ApplicantCurrentSprint";
import ApplicantSprintList from "./userPages/applicantSprintList/ApplicantSprintList";
import ApplicantSprintDetail from "./userPages/applicantSprintList/ApplicantSprintDetail";

import EditMember from "./userPages/volunteers/EditMember";
import MemberTermsList from "./userPages/volunteers/MemberTermsList";
import MemberTermAttendance from "./userPages/volunteers/MemberTermAttendance";

import CurrentSprint from "./userPages/sprints/CurrentSprint";
import SprintDetail from "./userPages/sprints/SprintDetail";
import SprintList from "./userPages/sprints/SprintList";

import TeamTermNotes from "./userPages/teams/TeamTermNotes";

import StaffGroups from "./userPages/staff/Groups";
import StaffTermsList from "./userPages/staff/StaffTermsList";

import DownloadApplicantsReport from "./userPages/reports/downloadApplicants";

import CryptoJS from "crypto-js";

const theme = createMuiTheme({
  shadows: ["none"],
  typography,
  palette,
});

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "#F5F5F5",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    //  flex: "1 1 auto",
    overflow: "auto",
    minHeight: "100vh",
    minWidth: "1790px", //1500 IE-111 SP
  },
  sideMenuWrapper: {
    display: "flex",
    flexDirection: "row",
    minWidth: "1400px",
  },
  wrapper: {
    overflow: "auto",
    flex: "1 1 auto",
    paddingTop: "6rem",
    justifyContent: "center",
    alignItems: "center",
  },
}));

function App() {
  const classes = useStyles();
  //localStorage.removeItem("token");
  const getToken = () => localStorage.getItem("token");
  const token = getToken();
  const [sideMenu, setSideMenu] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [previewPage, setPreviewPage] = useState(false);
  const [publicPage, setPublicPage] = useState(false);

  const client = new GraphQLClient({
    // url: 'http://localhost:8000' + `${project_url}/graphql`,
    // useGETForQueries: false,
    url: `${project_url}/graphql`,
    headers: { Authorization: token ? `JWT ${token}` : "" },
    fetchOptions: () => {
      return {
        headers: { Authorization: token ? `JWT ${token}` : "" },
      };
    },
  });

  const adminPaths = project_url + admin_string;

  const HandleAdminLogout = () => {
    setSideMenu(null);
    return <AdminLogout />;
  };

  //SP IE:111 Add Client side menu
  const HandleLogout = () => {
    setSideMenu(null);
    return <Logout />;
  };
  const HandleHome = ({ homeTarget }) => {
    setSideMenu(null);
    var role = null;
    if (localStorage.getItem("role"))
      role = CryptoJS.AES.decrypt(localStorage.getItem("role"), secretPass).toString(
        CryptoJS.enc.Utf8
      );

    if (role == "" || !role) window.location.href = `${project_url}/signin`;
    else if (role == "Admin") window.location.href = adminPaths + "/dashboard";
    else if (role == "Tenant") window.location.href = `${project_url}/tenant/dashboard`;
    else if (role == "Applicant") window.location.href = `${project_url}/applicant/dashboard`;
  };

  const SiteAdminPageLayout = () => {
    const location = useLocation();
    if (localStorage.getItem("token")) {
      setSideMenu("adminMenu");
    } else setSideMenu(null);

    if (location.pathname.indexOf(adminPaths + "/dashboard") != -1) {
      setSelectedMenu("Dashboard");
      return <AdminDashboard />;
    }
  };

  const FormPageLayout = () => {
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("Forms");
    } else setSideMenu(null);
    return <FormContainer />;
  };

  const GroupsPageLayout = () => {
    const location = useLocation();
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("General Settings");
    } else setSideMenu(null);

    if (location.pathname.indexOf(`${project_url}/groups/add`) != -1) return <AddGroup />;
    else if (location.pathname.indexOf(`${project_url}/groups`) != -1) return <Groups />;
  };

  const GroupIdPageLayout = () => {
    const location = useLocation();
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("General Settings");
    } else setSideMenu(null);
    if (location.pathname.indexOf("/group-permissions-ui") != -1)
      return <GroupPermissionsUI />;
    else if (location.pathname.indexOf("/group-permissions") != -1)
      return <GroupPermissions />;
    else if (location.pathname.indexOf(`${project_url}/groups/`) != -1) return <GroupDetail />;
  };

  const VolunteerPageLayout = () => {
    const location = useLocation();
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("Members");
    } else setSideMenu(null);    
    if (location.pathname.indexOf(`${project_url}/members`) != -1) {
      return <ClientMembersList />;
    }
  };
  const AddMemberPageLayout = () => {
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("Members");
    } else setSideMenu(null);
    return <ClientMembersAdd />;
  };
  const EditMemberPageLayout = () => {
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("Members");
    } else setSideMenu(null);
    return <EditMember />;
  };
  const MemberTermsListPageLayout = () => {
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("Members");
    } else setSideMenu(null);
    return <MemberTermsList />;
  };
  const MemberTermAttendancePageLayout = () => {
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("Members");
    } else setSideMenu(null);
    return <MemberTermAttendance />;
  };

  const FormUuidPageLayout = () => {
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("Forms");
    } else setSideMenu(null);
    return <FormDialog />;
  };

  const OrderFormPageLayout = () => {
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("Forms");
    } else setSideMenu(null);
    return <OrderFormDialog />;
  };
  const ScorePageUuidPageLayout = () => {
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("Forms");
    } else setSideMenu(null);
    return <ScorePage />;
  };

  const TermsPageLayout = () => {
    const location = useLocation();
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("Terms");
    } else setSideMenu(null);
    if (location.pathname.indexOf("/teams-assignment-static") != -1) {
      return <TeamsAssignment />;
    } else if (location.pathname.indexOf("/teams-resources-note") != -1) {
      return <TeamsResourcesNotes />;
    } else if (location.pathname.indexOf("/teams-assignment") != -1) {
      return <TeamsAssignmentFull />;
    } else if (location.pathname.indexOf(`${project_url}/terms/add-ui`) != -1) return <AddTermUI />;
    else if (location.pathname.indexOf(`${project_url}/terms/add`) != -1) return <AddTerm />;
    else if (location.pathname.indexOf("/applicants/ui") != -1)
      return <ApplicantsBoard />;
    else if (location.pathname.indexOf("/applicants") != -1)
      return <ApplicantsBoardFull />;
    else if (location.pathname.indexOf("/teams-resources-attendance") != -1)
      return <TeamsResourcesAttendance />;
    else if (location.pathname.indexOf(`${project_url}/terms`) != -1) {
      const idStart = location.pathname.indexOf(`${project_url}/terms`) + "/terms/".length;
      const idEnd = location.pathname.indexOf("/", idStart);
      if (idEnd !== -1) {
        setSelectedMenu("Terms");
        return <EditTerm />;
      } else return <Terms />;
    }
  };
  const TeamsPageLayout = () => {
    const location = useLocation();
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("Teams");
    } else setSideMenu(null);

    if (location.pathname.indexOf(`${project_url}/teams/add`) != -1) return <AddTeam />;
    else if (location.pathname.indexOf(`${project_url}/teams`) != -1) return <Teams />;
  };

  const TeamIdPageLayout = () => {
    const location = useLocation();
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("Teams");
    } else setSideMenu(null);

    if (location.pathname.indexOf("/terms") != -1) return <TeamTermsList />;
    else if (location.pathname.indexOf("/notes") != -1) return <TeamTermNotes />;
    else if (location.pathname.indexOf("/team-term") != -1) return <TeamTermActivity />;
    else if (location.pathname.indexOf(`${project_url}/teams/`) != -1) return <TeamDetail />;
  };

  const TenantsPageLayout = () => {
    const location = useLocation();

    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
    } else setSideMenu(null);
    if (location.pathname.indexOf(`${project_url}/clients/add`) != -1) {
      setSelectedMenu("Clients");
      return <AddClient />;
    } else if (location.pathname.indexOf(`${project_url}/clients`) != -1) {
      setSelectedMenu("Clients");
      return <Clients />;
    } else if (location.pathname.indexOf(`${project_url}/staff/add`) != -1) {
      setSelectedMenu("Users");
      return <AddUser />;
    } else if (location.pathname.indexOf(`${project_url}/staff`) !== -1) {
      if (location.pathname.indexOf("/group-permissions") !== -1) {
        setSelectedMenu("Users");
        return <UserGroupPermissions />;
      }

      else if (location.pathname.indexOf("/combined-group-permissions") !== -1) {
        setSelectedMenu("Users");
        return <UserCombinedGroupPermissions />;
      }

      else if (location.pathname.indexOf("/groups") !== -1) {
        setSelectedMenu("Users");
        return <StaffGroups />;
      }
      else if (location.pathname.indexOf("/staff-terms") !== -1) {
        setSelectedMenu("Users");
        return <StaffTermsList />;
      }
      const idStart = location.pathname.indexOf(`${project_url}/staff`) + "/staff/".length;
      const idEnd = location.pathname.indexOf("/", idStart);

      if (idEnd !== -1 || idStart < location.pathname.length) {
        setSelectedMenu("Users");
        return <EditUser />;
      }
    } else if (location.pathname.indexOf(`${project_url}/reports`) !== -1) {
      if (location.pathname.indexOf("/download_applicants") !== -1) {
        setSelectedMenu("Reports");
        return <DownloadApplicantsReport />;
      }
    } else if (location.pathname.indexOf(`${project_url}/tenant/dashboard-ui`) != -1) {
      setSelectedMenu("Dashboard");
      return <TenantUI />;
    } else if (location.pathname.indexOf(`${project_url}/tenant/dashboard`) != -1) {
      setSelectedMenu("Dashboard");
      return <Tenant />;
    } else if (location.pathname.indexOf(`${project_url}/tenant/settings/event_types`) != -1) {
      setSelectedMenu("General Settings");
      return <ManageEventTypes />;
    } else if (location.pathname.indexOf(`${project_url}/tenant/settings/roles`) != -1) {
      setSelectedMenu("General Settings");
      return <ManageRoles />;
    } else if (location.pathname.indexOf(`${project_url}/tenant/settings/term_templates`) != -1) {
      setSelectedMenu("General Settings");
      return <ManageTermTemplates />;
    } else if (location.pathname.indexOf(`${project_url}/tenant/settings/countries`) != -1) {
      setSelectedMenu("General Settings");
      return <ManageCountries />;
    } else if (location.pathname.indexOf(`${project_url}/tenant/settings/states`) != -1) {
      setSelectedMenu("General Settings");
      return <ManageStates />;
    } else if (location.pathname.indexOf(`${project_url}/tenant/settings/term`) != -1) {
      setSelectedMenu("General Settings");
      return <ConfigureTermSettings />;
    } else if (location.pathname.indexOf(`${project_url}/tenant/settings`) != -1) {
      setSelectedMenu("General Settings");
      return <TenantSettings />;
    } else if (location.pathname.indexOf(`${project_url}/tenant/TBD`) != -1) return <ToBeDev />;
  };

  const ApplicantsPageLayout = () => {
    const location = useLocation();
    if (localStorage.getItem("token")) {
      setSideMenu("applicantMenu");
      setSelectedMenu(null);
    } else setSideMenu(null);

    if (location.pathname.indexOf(`${project_url}/applicant/dashboard`) != -1) return <Applicant />;
    else if (location.pathname.indexOf(`${project_url}/applicant/TBD`) != -1) return <ToBeDev />;
  };

  const ApplicationsPageLayout = () => {
    const location = useLocation();
    if (localStorage.getItem("token")) {
      setSideMenu("applicantMenu");
      setSelectedMenu("Applications");
    } else setSideMenu(null);

    if (location.pathname.indexOf(`${project_url}/applicant/applications`) != -1)
      return <Applications />;
    else if (location.pathname.indexOf("/application-view") != -1)
      return <ApplicationView />;
  };

  const ClientIdPageLayout = () => {
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("Clients");
    } else setSideMenu(null);
    return <EditClient />;
  };

  const FormPreviewLayout = () => {
    setPreviewPage(true);
    setSideMenu(null);
    return <FormPreview />;
  };

  const ClientPublicFormLayout = () => {
    const location = useLocation();
    setPublicPage(true);
    setSideMenu(null);
    if (location.pathname.indexOf("/application-form") != -1) return <ClientPublicForm />;
  };

  const PublicFormLayout = () => {
    const location = useLocation();
    setPublicPage(true);
    setSideMenu(null);

    if (location.pathname.indexOf("/application-form-submitted") != -1) {
      return <SubmittedForm />;
    } else if (location.pathname.indexOf("/application-form") != -1)
      return <PublicForm />;
    else if (location.pathname.indexOf("/applicant_activation_confirmation") != -1)
      return <ApplicantActivationConfirmation />;
  };
  const AllPageLayout = () => {
    const location = useLocation();
    if (location.pathname.indexOf(`${project_url}/forms/:formUuid/preview`) != -1)
      setPreviewPage(false);
    if (location.pathname.indexOf(`${project_url}/terms/:termUuid/application-form`) != -1)
      setPublicPage(false);
    return <></>;
  };

  const ProfilePageLayout = () => {
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu(null);
    } else setSideMenu(null);
    return <Profile />;
  };

  const SettingsPageLayout = () => {
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu(null);
    } else setSideMenu(null);
    return <Settings />;
  };
  const ApplicantProfilePageLayout = () => {
    const location = useLocation();
    if (localStorage.getItem("token")) {
      setSideMenu("applicantMenu");
      setSelectedMenu(null);
    } else setSideMenu(null);

    if (location.pathname.indexOf(`${project_url}/applicant/profile`) != -1)
      return <ApplicantProfile />;
  };

  const ApplicantCurrentSprintPageLayout = () => {
    const location = useLocation();
    if (localStorage.getItem("token")) {
      setSideMenu("applicantMenu");
      setSelectedMenu("Sprints");
    } else setSideMenu(null);

    if (location.pathname.indexOf(`${project_url}/applicant/sprints/current`) != -1)
      return <ApplicantCurrentSprint />;
  };
  
  const ApplicantSprintPageLayout = () => {
    const location = useLocation();
    if (localStorage.getItem("token")) {
      setSideMenu("applicantMenu");
      setSelectedMenu("Sprints");
    } else setSideMenu(null);

    if (location.pathname.indexOf(`${project_url}/applicant/sprints`) != -1)
      return <ApplicantSprintList />;
  };
  
  const ApplicantSprintDetailLayout = () => {
    const location = useLocation();
    if (localStorage.getItem("token")) {
      setSideMenu("applicantMenu");
      setSelectedMenu("Sprints");
    } else setSideMenu(null);

    if (location.pathname.indexOf(`${project_url}/applicant/sprints/`) != -1)
      return <ApplicantSprintDetail />;
  };

  const UserPageLayout = () => {
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("Users");
    } else setSideMenu(null);
    return <UserContainer />;
  };

  const TermTemplateDetailPageLayout = () => {
    if (localStorage.getItem("token")) {
      setSideMenu("tenantMenu");
      setSelectedMenu("General Settings");
    } else setSideMenu(null);
    return <TermTemplatesDetail />;
  };

  const SprintPageLayout = () => {
    const { termUuid } = useParams();

    if (termUuid) {
      return <SprintDetail />;
    }

    return <SprintList />;
  };

  ////////////////////////
  const tenantPaths = `${project_url}/tenant`;
  const tenantFormPaths = `${project_url}/forms`;
  const tenantTermsPaths = `${project_url}/terms`;
  const tenantClientsPaths = `${project_url}/clients`;
  const tenantUsersPaths = `${project_url}/staff`;
  const tenantTeamsPaths = `${project_url}/teams`;
  const tenantTermTemplatesPaths = `${project_url}/term_templates`;
  const memberPaths = `${project_url}/members`;
  const tenantGroupsPaths = `${project_url}/groups`;
  const reportsPaths = `${project_url}/reports`;

  const ProtectedTenantGroups = () => {
    var role = null;
    var applicantDashboard = {project_url} + "/applicant/dashboard"
    if (localStorage.getItem("role"))
      role = CryptoJS.AES.decrypt(localStorage.getItem("role"), secretPass).toString(
        CryptoJS.enc.Utf8
      );
    if (!role) window.location.href = `${project_url}/signin`;
    else if (role !== "Tenant") {
      return (
        <h3>
          <br />
          <center>
            No Access! You either tried a suspicious action or came here by mistake.
            Please try using the navigation system or start from Home.
            <br />
            <br />
            {role === "Applicant" ? (
              <Link to={applicantDashboard}>Go to Home</Link>
            ) : (
              ""
            )}
          </center>
        </h3>
      );
    }
    return <GroupsPageLayout />;
  };

  const ProtectedTenantForm = () => {
    var role = null;
    var applicantDashboard = {project_url} + "/applicant/dashboard"
    if (localStorage.getItem("role"))
      role = CryptoJS.AES.decrypt(localStorage.getItem("role"), secretPass).toString(
        CryptoJS.enc.Utf8
      );
    if (!role) window.location.href = `${project_url}/signin`;
    else if (role !== "Tenant") {
      return (
        <h3>
          <br />
          <center>
            No Access! You either tried a suspicious action or came here by mistake.
            Please try using the navigation system or start from Home.
            <br />
            <br />
            {role === "Applicant" ? (
              <Link to={applicantDashboard}>Go to Home</Link>
            ) : (
              ""
            )}
          </center>
        </h3>
      );
    }
    return <FormPageLayout />;
  };

  const ProtectedTenantLayout = () => {
    var role = null;
    var applicantDashboard = {project_url} + "/applicant/dashboard"
    if (localStorage.getItem("role"))
      role = CryptoJS.AES.decrypt(localStorage.getItem("role"), secretPass).toString(
        CryptoJS.enc.Utf8
      );
    if (!role) window.location.href = `${project_url}/signin`;
    else if (role !== "Tenant") {
      return (
        <h3>
          <br />
          <center>
            No Access! You either tried a suspicious action or came here by mistake.
            Please try using the navigation system or start from Home.
            <br />
            <br />
            {role === "Applicant" ? (
              <Link to={applicantDashboard}>Go to Home</Link>
            ) : (
              ""
            )}
          </center>
        </h3>
      );
    }
    return (
      <div>
        <Outlet />
      </div>
    );
  };

  const ProtectedTenantTerms = () => {
    var role = null;
    var applicantDashboard = {project_url} + "/applicant/dashboard"
    if (localStorage.getItem("role"))
      role = CryptoJS.AES.decrypt(localStorage.getItem("role"), secretPass).toString(
        CryptoJS.enc.Utf8
      );
    if (!role) window.location.href = `${project_url}/signin`;
    else if (role !== "Tenant") {
      return (
        <h3>
          <br />
          <center>
            No Access! You either tried a suspicious action or came here by mistake.
            Please try using the navigation system or start from Home.
            <br />
            <br />
            {role === "Applicant" ? (
              <Link to={applicantDashboard}>Go to Home</Link>
            ) : (
              ""
            )}
          </center>
        </h3>
      );
    }
    return <TermsPageLayout />;
  };
  const ProtectedTenantTeams = () => {
    var role = null;
    var applicantDashboard = {project_url} + "/applicant/dashboard"
    if (localStorage.getItem("role"))
      role = CryptoJS.AES.decrypt(localStorage.getItem("role"), secretPass).toString(
        CryptoJS.enc.Utf8
      );
    if (!role) window.location.href = `${project_url}/signin`;
    else if (role !== "Tenant") {
      return (
        <h3>
          <br />
          <center>
            No Access! You either tried a suspicious action or came here by mistake.
            Please try using the navigation system or start from Home.
            <br />
            <br />
            {role === "Applicant" ? (
              <Link to={applicantDashboard}>Go to Home</Link>
            ) : (
              ""
            )}
          </center>
        </h3>
      );
    }
    return <TeamsPageLayout />;
  };
  const ProtectedTenantVolunteerPage = () => {
    var role = null;
    var applicantDashboard = {project_url} + "/applicant/dashboard"
    if (localStorage.getItem("role"))
      role = CryptoJS.AES.decrypt(localStorage.getItem("role"), secretPass).toString(
        CryptoJS.enc.Utf8
      );
    if (!role) window.location.href = `${project_url}/signin`;
    else if (role !== "Tenant") {
      return (
        <h3>
          <br />
          <center>
            No Access! You either tried a suspicious action or came here by mistake.
            Please try using the navigation system or start from Home.
            <br />
            <br />
            {role === "Applicant" ? (
              <Link to={applicantDashboard}>Go to Home</Link>
            ) : (
              ""
            )}
          </center>
        </h3>
      );
    }
    return <VolunteerPageLayout />;
  };

  const ProtectedTenantClients = () => {
    console.log("window.location", window.location);
    var role = null;
    var applicantDashboard = {project_url} + "/applicant/dashboard"
    if (localStorage.getItem("role"))
      role = CryptoJS.AES.decrypt(localStorage.getItem("role"), secretPass).toString(
        CryptoJS.enc.Utf8
      );
    if (!role) window.location.href = `${project_url}/signin`;
    else if (role !== "Tenant") {
      return (
        <h3>
          <br />
          <center>
            No Access! You either tried a suspicious action or came here by mistake.
            Please try using the navigation system or start from Home.
            <br />
            <br />
            {role === "Applicant" ? (
              <Link to={applicantDashboard}>Go to Home</Link>
            ) : (
              ""
            )}
          </center>
        </h3>
      );
    }
    return <TenantsPageLayout />;
  };

  const ProtectedTenantUsers = () => {
    var role = null;
    var applicantDashboard = {project_url} + "/applicant/dashboard"
    if (localStorage.getItem("role"))
      role = CryptoJS.AES.decrypt(localStorage.getItem("role"), secretPass).toString(
        CryptoJS.enc.Utf8
      );
    if (!role) window.location.href = `${project_url}/signin`;
    else if (role !== "Tenant") {
      return (
        <h3>
          <br />
          <center>
            No Access! You either tried a suspicious action or came here by mistake.
            Please try using the navigation system or start from Home.
            <br />
            <br />
            {role === "Applicant" ? (
              <Link to={applicantDashboard}>Go to Home</Link>
            ) : (
              ""
            )}
          </center>
        </h3>
      );
    }
    return <UserPageLayout />;
  };

  const ProtectedTenantSprints = () => {
    var role = null;
    var applicantDashboard = {project_url} + "/applicant/dashboard"
    if (localStorage.getItem("role"))
      role = CryptoJS.AES.decrypt(localStorage.getItem("role"), secretPass).toString(
        CryptoJS.enc.Utf8
      );
    if (!role) window.location.href = `${project_url}/signin`;
    else if (role !== "Tenant") {
      return (
        <h3>
          <br />
          <center>
            No Access! You either tried a suspicious action or came here by mistake.
            Please try using the navigation system or start from Home.
            <br />
            <br />
            {role === "Applicant" ? (
              <Link to={applicantDashboard}>Go to Home</Link>
            ) : (
              ""
            )}
          </center>
        </h3>
      );
    }
    return <SprintPageLayout />;
  };

  const applicantPaths = `${project_url}/applicant`;

  const ProtectedApplicantLayout = () => {
    var role = null;
    var tenantDashboard = {project_url} + "/tenant/dashboard"
    if (localStorage.getItem("role"))
      role = CryptoJS.AES.decrypt(localStorage.getItem("role"), secretPass).toString(
        CryptoJS.enc.Utf8
      );
    if (!role) window.location.href = `${project_url}/signin`;
    else if (role !== "Applicant") {
      return (
        <h3>
          <br />
          <center>
            No Access! You either tried a suspicious action or came here by mistake.
            Please try using the navigation system or start from Home.
            <br />
            <br />
            {role === "Tenant" ? <Link to={tenantDashboard}>Go to Home</Link> : ""}
          </center>
        </h3>
      );
    }
    return (
      <div>
        <Outlet />
      </div>
    );
  };

  ////////////////////////
  return (
    <ClientContext.Provider value={client}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <div className={!publicPage ? classes.root : null}>
            {!previewPage && !publicPage && <Header />}
            <div
              className={
                sideMenu ? classes.sideMenuWrapper : !publicPage ? classes.wrapper : null
              }
            >
              {sideMenu && sideMenu === "adminMenu" && (
                <SiteAdminSideMenu selectedMenu={selectedMenu} />
              )}

              {sideMenu && sideMenu === "tenantMenu" && (
                <TenantSideMenu selectedMenu={selectedMenu} />
              )}

              {sideMenu && sideMenu === "applicantMenu" && (
                <ApplicantSideMenu selectedMenu={selectedMenu} />
              )}
              <AllPageLayout />
              <Routes>
                {/* Admin Pages */}
                <Route path={adminPaths + "/signin"} element={<AdminSignIn />} />
                <Route
                  path={adminPaths + "/dashboard"}
                  element={<SiteAdminPageLayout />}
                />
                <Route path={adminPaths + "/signout"} element={<HandleAdminLogout />} />

                <Route
                  path={adminPaths + "/applicant_answers_scores"}
                  element={<ApplicantsAnswersScores />}
                />
                <Route path="*" element={<HandleHome />} />

                {/* Tenant itself Pages */}
                <Route path={tenantPaths} element={<ProtectedTenantLayout />}>
                  <Route path="dashboard" element={<TenantsPageLayout />} />
                  <Route path="dashboard-ui" element={<TenantsPageLayout />} />
                  <Route path="settings" element={<TenantsPageLayout />} />
                  <Route path="settings/roles" element={<TenantsPageLayout />} />
                  <Route path="settings/countries" element={<TenantsPageLayout />} />
                  <Route path="settings/states" element={<TenantsPageLayout />} />
                  <Route path="settings/event_types" element={<TenantsPageLayout />} />
                  <Route path="settings/term_templates" element={<TenantsPageLayout />} />
                  <Route
                    path="settings/term_templates/:termTemplateUuid"
                    element={<TermTemplateDetailPageLayout />}
                  />

                  <Route path="settings/term" element={<TenantsPageLayout />} />
                  <Route path="TBD" element={<TenantsPageLayout />} />
                </Route>

                {/* Tenant Group Pages */}
                <Route path= { project_url + "/groups"} element={<ProtectedTenantGroups />} />
                <Route path={tenantGroupsPaths} element={<ProtectedTenantLayout />}>
                  <Route path="add" element={<GroupsPageLayout />} />
                  <Route
                    path=":groupUuid/group-permissions"
                    element={<GroupIdPageLayout />}
                  />
                  <Route
                    path=":groupUuid/group-permissions-ui"
                    element={<GroupIdPageLayout />}
                  />
                  <Route path=":groupUuid" element={<GroupIdPageLayout />} />
                </Route>

                {/* Tenant Form Pages */}
                <Route path={ project_url + "/forms" } element={<ProtectedTenantForm />} />
                <Route path={tenantFormPaths} element={<ProtectedTenantLayout />}>
                  {/* <Route path= project_url + "/forms_SP" element={<FormContainerSP />} /> */}
                  <Route path=":formUuid" element={<FormUuidPageLayout />} />
                  <Route
                    path=":formUuid/reorder-objects"
                    element={<OrderFormPageLayout />}
                  />
                  <Route path="order_forms/:formId" element={<OrderFormDialogSP />} />
                  <Route
                    path=":formUuid/assign-score"
                    element={<ScorePageUuidPageLayout />}
                  />
                  <Route path=":formUuid/preview" element={<FormPreviewLayout />} />
                  <Route path=":formUuid/preview-edit" element={<FormPreviewLayout />} />
                </Route>

                {/* Members Pages */}
                <Route path= { project_url + "/members" } element={<ProtectedTenantVolunteerPage />} />
                <Route path={memberPaths} element={<ProtectedTenantLayout />}>
                  <Route path="add" element={<AddMemberPageLayout />} />
                  <Route path=":clientMemberId" element={<EditMemberPageLayout />} />
                  <Route path=":userUuid/terms" element={<MemberTermsListPageLayout />} />
                  <Route
                    path=":userUuid/terms/:termUuid/:teamUuid/attendance"
                    element={<MemberTermAttendancePageLayout />}
                  />
                </Route>

                {/* Reports Pages */}
                <Route path={reportsPaths} element={<ProtectedTenantLayout />}>
                  <Route path="download_applicants" element={<TenantsPageLayout />} />
                  />
                </Route>                
                reportsPaths

                {/* Tenant Terms Pages */}
                <Route path= { project_url + "/terms" } element={<ProtectedTenantTerms />} />
                <Route path={tenantTermsPaths} element={<ProtectedTenantLayout />}>
                  <Route path="add" element={<TermsPageLayout />} />
                  <Route path=":termUuid" element={<TermsPageLayout />} />
                  <Route path="add-ui" element={<TermsPageLayout />} />
                  <Route path=":termUuid/applicants" element={<TermsPageLayout />} />
                  <Route path=":termUuid/applicants/ui" element={<TermsPageLayout />} />
                  <Route
                    path=":termUuid/teams-resources-note"
                    element={<TermsPageLayout />}
                  />
                  <Route
                    path=":termUuid/teams-resources-attendance"
                    element={<TermsPageLayout />}
                  />
                  <Route
                    path=":termUuid/teams-assignment-static"
                    element={<TermsPageLayout />}
                  />
                  <Route
                    path=":termUuid/teams-assignment"
                    element={<TermsPageLayout />}
                  />
                </Route>

                <Route
                  path={ project_url + "/terms/:termUuid/application-form-submitted/" }
                  element={<PublicFormLayout />}
                />

                <Route
                  path={ project_url + "/terms/:termUuid/application-form" }
                  element={<PublicFormLayout />}
                />

                <Route
                  path={ project_url + "/client/:clientUuid/application-form" }
                  element={<ClientPublicFormLayout />}
                />

                {/* Tenant Client Pages */}
                <Route path={ project_url + "/clients" } element={<ProtectedTenantClients />} />
                <Route path={tenantClientsPaths} element={<ProtectedTenantLayout />}>
                  <Route path="add" element={<TenantsPageLayout />} />
                  <Route path=":clientUuid" element={<ClientIdPageLayout />} />
                </Route>

                {/* Tenant Teams Pages */}
                <Route path={ project_url + "/teams" } element={<ProtectedTenantTeams />} />
                <Route path={tenantTeamsPaths} element={<ProtectedTenantLayout />}>
                  <Route path="add" element={<TeamsPageLayout />} />
                  <Route path=":teamUuid" element={<TeamIdPageLayout />} />
                  <Route path=":teamUuid/terms" element={<TeamIdPageLayout />} />
                  <Route
                    path=":teamUuid/team-term/:termUuid"
                    element={<TeamIdPageLayout />}
                  />
                  <Route path=":teamUuid/notes" element={<TeamIdPageLayout />} />
                </Route>

                {/* Tenant User Pages */}
                <Route path={ project_url + "/staff" } element={<ProtectedTenantUsers />} />
                <Route path={tenantUsersPaths} element={<ProtectedTenantLayout />}>
                  <Route path="add" element={<TenantsPageLayout />} />
                  <Route path=":userId" element={<TenantsPageLayout />} />
                  {/* <Route path=":userId/groups" element={<TenantsPageLayout />} /> */}
                  <Route path=":staffUuid/groups" element={<TenantsPageLayout />} />
                  <Route path=":staffUuid/staff-terms" element={<TenantsPageLayout />} />
                  <Route
                    path=":userId/groups/:groupUuid/group-permissions"
                    element={<TenantsPageLayout />}
                  />

                <Route
                    path=":username/groups/combined-group-permissions"
                    element={<TenantsPageLayout />}
                  />
                </Route>

                {/* Applicant Pages */}
                <Route path={applicantPaths} element={<ProtectedApplicantLayout />}>
                  <Route path="dashboard" element={<ApplicantsPageLayout />} />

                  <Route path="applications" element={<ApplicationsPageLayout />} />
                  <Route
                    path=":termUuid/application-view"
                    element={<ApplicationsPageLayout />}
                  />
                  <Route path="TBD" element={<ApplicantsPageLayout />} />

                  <Route path="profile" element={<ApplicantProfilePageLayout />} />
                  
                  <Route
                    path="sprints/current"
                    element={<ApplicantCurrentSprintPageLayout />}
                  />
                  <Route
                    path="sprints"
                    element={<ApplicantSprintPageLayout />}
                  />
                  <Route 
                    path="sprints/:termUuid"
                    element={<ApplicantSprintDetailLayout />} />
                </Route>

                {MULTI_TENANT && (<Route path={ project_url + "/registration" } element={<Registration />} />)}
                <Route path={ project_url + "/register_success" } element={<SuccessRegistration />} />
                <Route
                  path={ project_url + "/register_activation/:activationCode" }
                  element={<Activation />}
                />
                <Route
                  path={ project_url + "/applicant_activation_confirmation" }
                  element={<PublicFormLayout />}
                />
                <Route
                  path={ project_url + "/applicant_activation/:activationCode" }
                  element={<ApplicantActivation />}
                />

                <Route
                  path={ project_url + "/onboarded_member_activation_confirmation" }
                  element={<OnboardedMemberActivationConfirmation />}
                />
                <Route
                  path={ project_url + "/onboarded_member_activation/:activationCode" }
                  element={<OnboardedMemberActivation />}
                />

                <Route
                  path={ project_url + "/account_activation/:activationCode" }
                  element={<AccountActivation />}
                />
                <Route
                  path={ project_url + "/account_activation_confirmation/:activationCode" }
                  element={<AccountActivationConfirmation />}
                />
                <Route path={ project_url + "/signin" } element={<SignIn />} />
                <Route path={ project_url + "/signout"} element={<HandleLogout />} />
                <Route path={ project_url + "/forgot_password"} element={<ForgetPass />} />
                <Route path={ project_url + "/reset_password/:forgetCode" } element={<ResetPass />} />
                <Route
                  path={ project_url + "/reset_password_confirmation" }
                  element={<ResetPassConfirmation />}
                />

                <Route path={ project_url + "/tests/rte/" } element={<RTETest />} />
                <Route path={ project_url + "/tests/tenant/" } element={<TenantTest />} />

                <Route path={ project_url + "/profile" } element={<ProfilePageLayout />} />

                {/* Tenant Sprints Pages */}
                <Route path={ project_url + "/sprints/:termUuid" } element={<ProtectedTenantSprints />} />
                <Route path={ project_url + "/sprints" } element={<ProtectedTenantSprints />} />
                
              </Routes>
            </div>
            {!previewPage && !publicPage && <Footer />}
          </div>
        </BrowserRouter>
      </ThemeProvider>
    </ClientContext.Provider>
  );
}
ReactDOM.render(<App />, document.getElementById("root"));
